export default "__VITE_ASSET__ChcReX8F__"